import { CircularProgress, makeStyles, TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useState } from "react";
import EvaluacionAPI, { FiscalReporte } from "src/services/evaluacion";

interface Props {
  className?: string;
  label: string;
  value: FiscalReporte | null;
  setValue: (f: FiscalReporte | null) => void;
  disabled?: boolean;
  error?: boolean;
}

const useStyles = makeStyles({
  option: { color: "#404040", fontWeight: "normal" },
});

const AutocompleteFiscalReporte: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<FiscalReporte[]>([]);
  const [input, setInput] = useState("");
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    const texto = (input || "").trim();

    if (props.disabled || !open) {
      setOptions([]);
      setLoading(false);
      return;
    }

    // Si el usuario está escribiendo pero aún no llega a 2 caracteres, no consultar
    if (texto.length > 0 && texto.length < 2) {
      setOptions([]);
      setLoading(false);
      return;
    }

    let activo = true;
    setLoading(true);

    EvaluacionAPI.listarFiscalesReporte(texto)
      .then((arr) => {
        if (!activo) return;
        setOptions((arr || []).slice(0, 50));
      })
      .catch(() => {
        if (!activo) return;
        setOptions([]);
      })
      .finally(() => {
        if (!activo) return;
        setLoading(false);
      });

    return () => {
      activo = false;
    };
  }, [input, props.disabled, open]);

  return (
    <MuiAutocomplete
      autoComplete
      className={props.className}
      classes={{ option: classes.option }}
      options={options}
      filterOptions={(opts) => opts}
      getOptionLabel={(o) => `${o.nombre} (${o.cedula})`}
      getOptionSelected={(o, v) => o.cedula === v.cedula}
      value={props.value}
      onChange={(e, v) => props.setValue(v)}
      inputValue={input}
      onInputChange={(e, v, reason) => {
        (reason !== "reset" || (reason === "reset" && v !== "")) && setInput(v);
      }}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disabled={props.disabled}
      loading={loading}
      loadingText="Cargando..."
      noOptionsText={
        (input || "").trim().length > 0 && (input || "").trim().length < 2
          ? "Escriba al menos 2 caracteres"
          : "Sin coincidencias"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          variant="outlined"
          error={props.error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutocompleteFiscalReporte;
